import * as AddItemToCartActionTypes from '../actionTypes/AddItemToCartActionTypes';

export const addItemToCart = () => ({
    type: AddItemToCartActionTypes.ADD_ITEM_TO_CART_REQUEST,
});

export const setSelectedSku = (key) => ({
    type: AddItemToCartActionTypes.UPDATE_GIFT_CARD_BANNER_SELECTED_VALUE,
    key,
});

export const setGiftCardMsg = (status) => ({
    type: AddItemToCartActionTypes.ADD_GIFT_CARD_TO_CART_MESSAGE,
    status,
});

export const showGiftCardBanner = (payload) => ({
    type: AddItemToCartActionTypes.SHOW_GIFT_CARD_BANNER,
    value: payload.value,
});

export const initGiftCardBannerInfo = () => ({
    type: AddItemToCartActionTypes.INIT_GIFT_CARD_BANNER,
});

export const hideGiftCardBannerMessage = () => ({
    type: AddItemToCartActionTypes.HIDE_GIFT_CARD_BANNER_MESSAGE,
});
